import AppList, { makeSubArrays, determineCols } from "./AppList";

export default AppList;

export { AppList, makeSubArrays, determineCols };
